import React, { createContext, useReducer, useContext, useCallback } from 'react';

const initialState = {
  alerts: [],
  isLoading: false,
  modals: {}
};

const uiReducer = (state, action) => {
  switch (action.type) {
    case 'SHOW_ALERT':
      return {
        ...state,
        alerts: [...state.alerts, action.payload]
      };
    case 'HIDE_ALERT':
      return {
        ...state,
        alerts: state.alerts.filter((alert) => alert.id !== action.payload)
      };
    case 'SHOW_MODAL':
      return {
        ...state,
        modals: {
          ...state.modals,
          [action.payload.modalId]: action.payload.props
        }
      };
    case 'HIDE_MODAL': {
      const nextModals = { ...state.modals };
      delete nextModals[action.payload];
      return {
        ...state,
        modals: nextModals
      };
    }
    default:
      return state;
  }
};

export const UIContext = createContext(initialState);

export const UIProvider = ({ children }) => {
  const [state, dispatch] = useReducer(uiReducer, initialState);

  const showAlert = useCallback((message, type = 'info') => {
    const id = Date.now();
    dispatch({ type: 'SHOW_ALERT', payload: { id, message, type } });
    setTimeout(() => {
      dispatch({ type: 'HIDE_ALERT', payload: id });
    }, 3000);
  }, []);

  const showModal = useCallback((modalId, props = {}) => {
    dispatch({ type: 'SHOW_MODAL', payload: { modalId, props } });
  }, []);

  const hideModal = useCallback((modalId) => {
    dispatch({ type: 'HIDE_MODAL', payload: modalId });
  }, []);

  const value = {
    ...state,
    showAlert,
    showModal,
    hideModal
  };

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

export const useUI = () => useContext(UIContext);
